import { render } from "./AppTableText.vue?vue&type=template&id=931d01f2&scoped=true"
import script from "./AppTableText.vue?vue&type=script&lang=js"
export * from "./AppTableText.vue?vue&type=script&lang=js"

import "./AppTableText.vue?vue&type=style&index=0&id=931d01f2&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-931d01f2"]])

export default __exports__